import { IconWrap, LockBoldIcon } from '@libs/ui/ds'
import { useMemoSelector } from '@spa/redux/hooks'
import React from 'react'

import { payPeriodsSelectors } from '../../redux/selectors'

const LockedIcon = ({
  date,
  className
}: {
  date: string
  className?: string
}) => {
  const lockedDays = useMemoSelector(
    payPeriodsSelectors.getLockedDaysInTimerange
  )[date]

  if (!lockedDays?.isLocked) {
    return null
  }

  return <IconWrap className={className} size='s' icon={<LockBoldIcon />} />
}

export default LockedIcon
